import get from 'lodash/fp/get';

import { BOOKED } from './getBookingItineraryPath';

export default function getSourceName(booking) {
	const bookingStatus = get(['hotelProducts', 0, 'bookingStatus'])(booking);

	if (bookingStatus === BOOKED) {
		return 'Web - Pre-Arrival';
	}

	return 'Web - Shopping';
}
